/* CUSTOMIZER */
export const SET_USER_DATA: string = "SET_USER_DATA";
export const LOGIN: string = "LOGIN";
export const LOG_OUT: string = "LOG_OUT";
